export const SESSION_EXPIRED_REASON = "session-expired" as const
export const SESSION_EXPIRED_REDIRECT = `/login?reason=${SESSION_EXPIRED_REASON}` as const
